import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import DesignPage from '@/src/cms/models/DesignPage';
import CommitteesList from '@/src/committees/components/CommitteesList';
import CommitteesOverview from '@/src/committees/components/CommitteesList/CommitteesOverview';
import MemberCommittees from '@/src/committees/components/CommitteesList/MemberCommittees';
import AdminLink from '@/src/shared/components/AdminLink';
import Button from '@/src/shared/components/Button';
import Container from '@/src/shared/components/Container';
import Hero from '@/src/shared/components/Hero';
import Layout from '@/src/shared/components/Layout';
import withMembershipAccessWrap, {
  mapStateToProps,
} from '@/src/shared/components/MembershipPageWrap';
import Section from '@/src/shared/components/Section';
import WebLogImage from '@/src/shared/components/WebLogImage';
import { ADVOCACY_ACCESS } from '@/src/shared/constants';
import request from '@/utils/axios';
import { scrollToElement } from '@/utils/utils';
import { space } from '@/styles';
import CommitteeTerminology from '@/src/committees/components/CommitteeTerminologyModal';
const { m } = space;

const browseCommitteeHash = 'browseallcommittees';

const PolicyMakingCommittees = props => {
  const { isLoggedIn, personId, pagedata, messageData = {} } = props;
  const [designPageData, setPageData] = useState(pagedata);
  const [terminologyVisible, setTerminologyVisible] = useState(false);

  useEffect(() => {
    const fetchDesignPage = async () => {
      const pageResponse = await request({
        url: `cms/designpage`,
        params: {
          alias: 'committees',
        },
      });
      if (pageResponse.data?.DateLastUpdated !== pagedata?.DateLastUpdated) {
        setPageData(pageResponse.data);
      }
    };
    fetchDesignPage();
  }, []);

  const page = new DesignPage({ ...designPageData, ...messageData });
  const heroImage =
    page.HeroImageId && `${process.env.NEW_API_URL}image/file?area=c&id=${page.HeroImageId}`;

    async function handleTerminologyModalClose() {
      setTerminologyVisible(false);
    }

  return (
     <Layout>
      <AdminLink pageID="599" pageType="core" />
      <Hero title={page.HeroHeadline} bgImage={heroImage} type="image">
        <Button theme="default" size="small" onClick={() => scrollToElement(browseCommitteeHash)}>
          Browse All Committees
        </Button>
      </Hero>
      {isLoggedIn && personId ? <MemberCommittees personId={personId} /> : null}
      <Section bgColor="white">
        <Container style={{ paddingBottom: 0 }}>
          <div>
            <CommitteesOverview pagedata={page} />
            <div >
            <Button style={{ textAlign: 'left', paddingLeft: '0px' }}theme="link" onClick={() => setTerminologyVisible(true)}>
              APCIA Group Terminology
            </Button>
          </div>
        </div>
      </Container>
      </Section>
      <Section bgColor="gray" name={browseCommitteeHash} id={browseCommitteeHash}>
        <Container>
          <CommitteesList browseHash={browseCommitteeHash} />
        </Container>
      </Section><CommitteeTerminology
        visible={terminologyVisible}
        handleModalClose={handleTerminologyModalClose} /><WebLogImage path="/policy/committees" title={page.HeroHeadline} />
    </Layout>
  );
};

export async function getStaticProps() {
  const pageResponse = await request({
    url: `cms/designpage`,
    params: {
      alias: 'committees',
    },
  });
  return {
    props: {
      pagedata: pageResponse.data,
    },
  };
}

export default connect(mapStateToProps)(
  withMembershipAccessWrap(PolicyMakingCommittees, ADVOCACY_ACCESS.POLICY_COMMITTEES)
);
